import React, { useState } from "react";
import { Typography, Box } from "@mui/material";
import { Button } from "react-bootstrap";
import FileUploads from "../Alert/FileUploads";
import { useLocation } from "react-router-dom";
import NavigationBar from "../NavigationBar/NavigationBarComponent";

const EmptyView: React.FC = () => {
  const location = useLocation();
  const selectedFolderData = location?.state?.payload;
  const selectedFolderPath = location?.state?.path;
  const [uploadFilesOpen, setUploadFilesOpen] = useState(false);

  const handelUploadFiles = () => {
    setUploadFilesOpen(true);
  };

  const closeUploadFiles = () => {
    setUploadFilesOpen(false);
  };
  return (
    <div>      
      <NavigationBar title={selectedFolderPath} text="" />
    <Box
      sx={{
        textAlign: "center",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
      className="ag-theme-quartz-dark"
    >
      <Typography variant="h4" color="var(--aggrid-text-color)">
        Please click on a further level or folder to view documents.
      </Typography>
      {selectedFolderData.isUploadFiles && (
        <Button
          variant="contained"
          size="sm"
          className="document-button"
          onClick={handelUploadFiles}
          style={{
            marginTop: "20px",
          }}
        >
          Upload
        </Button>
      )}
      {uploadFilesOpen && (
        <FileUploads
          isOpen={uploadFilesOpen}
          onClose={closeUploadFiles}
          title="Upload Files"
          selectedData={selectedFolderData}
          isOtherOption={true}
          screenType="Document"
        />
      )}
    </Box>
    </div>
  );
};

export default EmptyView;
